/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/RestrictionActionResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./RestrictionActionResource'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RestrictionResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.RestrictionActionResource);
  }
}(this, function(ApiClient, RestrictionActionResource) {
  'use strict';




  /**
   * The RestrictionResponse model module.
   * @module model/RestrictionResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RestrictionResponse</code>.
   * A response object for restriction.
   * @alias module:model/RestrictionResponse
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>RestrictionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RestrictionResponse} obj Optional instance to populate.
   * @return {module:model/RestrictionResponse} The populated <code>RestrictionResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('actions')) {
        obj['actions'] = ApiClient.convertToType(data['actions'], [RestrictionActionResource]);
      }
      if (data.hasOwnProperty('definition')) {
        obj['definition'] = ApiClient.convertToType(data['definition'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
      if (data.hasOwnProperty('autoAssign')) {
        obj['autoAssign'] = ApiClient.convertToType(data['autoAssign'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * The ID of restriction.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * The name of restriction.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * A collection of action that added to the restriction.
   * @member {Array.<module:model/RestrictionActionResource>} actions
   */
  exports.prototype['actions'] = undefined;
  /**
   * The JSON-formatted defintion of the restriction.
   * @member {String} definition
   */
  exports.prototype['definition'] = undefined;
  /**
   * The type of the restriction, such as \"HIT\", \"TIMEOFDAY\", \"ORIGIN\".
   * @member {String} type
   */
  exports.prototype['type'] = undefined;
  /**
   * A value indicates if this restriction will be assigned to the new user account automatically. \"true\", it will be assigned to the new user account, otherwise not.
   * @member {Boolean} autoAssign
   */
  exports.prototype['autoAssign'] = undefined;



  return exports;
}));



